import React from 'react';

function CTAStrip() {
  return (
    <>
      {/* CTA STRIP */}
<section className="cta-strip animate-on-scroll">
  <h2 className="cta-strip-h2">Your first transaction through<br />SpeedVault goes live in 48 hrs.</h2>
  <p className="cta-strip-lead">Join 500+ businesses who switched to SpeedVault and saw their UPI success rate climb above 99%. No lock-in. Month-to-month contracts.</p>
  <div className="cta-strip-actions">
    <a className="btn-strip-white btn-shimmer" href="https://speedvault.in/request_a_demo">Request a Demo</a>
    <a className="btn-strip-outline" href="https://speedvault.in/get_a_quote">Get a Quote →</a>
  </div>
</section>
    </>
  );
}

export default CTAStrip;
